export default "__VITE_ASSET__7f23803e__"